import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DecimalPlacesCustomPipe } from '../../../../@core/pipes';
import { DocumentLineItem } from '../../../../generated/generated-types';
import { ServerSettingsService } from '../../../../shared/services/server-settings.service';

@Component({
  selector: 'app-document-line-item-calc-prices',
  templateUrl: './document-line-item-calc-prices.component.html',
  styleUrls: ['./document-line-item-calc-prices.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DecimalPlacesCustomPipe,
  ]
})
export class DocumentLineItemCalcPricesComponent extends FieldType {

  @Input() documentLineItem: DocumentLineItem;
  proratedLinePrice: number;
  proratedLinePriceWithTax: number;
  decimalPlacesInputSettings: number;
  revenue: number;
  taxAmount: number;
  destroy$ = new Subject<void>();

  constructor(
    private serverSettingsService: ServerSettingsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.field.parent.formControl.valueChanges.subscribe((x: DocumentLineItem) => {
      this.proratedLinePrice = x.proratedLinePrice;
      this.proratedLinePriceWithTax = x.proratedLinePriceWithTax;
      this.taxAmount = x.proratedLineTax;
      this.revenue = x.revenue;
      this.options.detectChanges(this.field);
    })
  }

  ngAfterViewInit(): void {
    if (!this.decimalPlacesInputSettings)
      this.serverSettingsService.getRoundDecimalPlacesLineItem().then((x) => {
        this.decimalPlacesInputSettings = x;
      });
    if (!this.decimalPlacesInputSettings)
      this.serverSettingsService.getRoundDecimalPlaces().then((x) => {
        this.decimalPlacesInputSettings = x;
      });
  }

  ngOnDestroy(): void {
    this.field?.parent?.formControl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


}
